import React from 'react';

import Box from '@mui/material/Box';

import GenericList from '@ts-core/core/components/GenericList';

interface QuestionsContainerProps<TQuestion> {
  skeletonsCount?: number;
  loading?: boolean;
  questions?: TQuestion[];

  renderQuestion: (index: number, question?: TQuestion) => React.ReactNode;
}

const QuestionsContainer = <TQuestion extends object>(props: QuestionsContainerProps<TQuestion>) => {
  const { skeletonsCount = 2, loading, questions, renderQuestion } = props;
  return (
    <Box>
      <GenericList items={questions} loading={loading} skeletonsCount={skeletonsCount} renderItem={renderQuestion} />
    </Box>
  );
};

export default QuestionsContainer;
